<template>
	<div>
        <v-flex xs7 ml-5 mt-4>
            <v-layout wrap>
                <v-flex xs3 mr-3>
                    <v-text-field
                        background-color="white"
                        box
                        class="body-1"
                        hide-details
                        type="number"
                        label="Limite de Productos"
                        required
                        v-model="productLimit"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>
		</v-flex>
	</div>
</template>
<script>

function data() {
    return {
        productLimit: 0,
    };
}

function created() {
    this.productLimit = this.data.settings && this.data.settings.company ? this.data.settings.company.productLimit : 0;
}

export default {
    name: 'configuration-products',
    data,
    created,
    props: {
        data: {
            type: Object,
        },
    },
    watch: {
        productLimit(newVal) {
            this.$emit('update:productLimit', newVal, 'limitProducts');
        }
    },
};

</script>


// WEBPACK FOOTER //
// src/components/configuration-general/configuration-products.vue